export type { BannerCollectionData, BannerData } from './BannerSlider';
export { default } from './BannerSlider';
